// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-type-picker {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 100;
  min-width: 160px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.item-type-picker--portal {
  position: fixed;
  z-index: 9999;
}

.item-type-picker__header {
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.item-type-picker__list {
  list-style: none;
  margin: 0;
  padding: 4px 0;
}

.item-type-picker__option {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  font-size: 14px;
  color: #1e293b;
  transition: background-color 0.15s ease;
}

.item-type-picker__option:hover {
  background-color: #f1f5f9;
}

.item-type-picker__icon {
  font-size: 16px;
}

.item-type-picker__label {
  flex: 1;
}

.item-type-picker__loading {
  padding: 12px;
  text-align: center;
  color: #64748b;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/ItemTypePicker/ItemTypePicker.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".item-type-picker {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 100;\n  min-width: 160px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n}\n\n.item-type-picker--portal {\n  position: fixed;\n  z-index: 9999;\n}\n\n.item-type-picker__header {\n  padding: 8px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.item-type-picker__list {\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n}\n\n.item-type-picker__option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 12px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  text-align: left;\n  font-size: 14px;\n  color: #1e293b;\n  transition: background-color 0.15s ease;\n}\n\n.item-type-picker__option:hover {\n  background-color: #f1f5f9;\n}\n\n.item-type-picker__icon {\n  font-size: 16px;\n}\n\n.item-type-picker__label {\n  flex: 1;\n}\n\n.item-type-picker__loading {\n  padding: 12px;\n  text-align: center;\n  color: #64748b;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
